import React, { useState, useEffect } from "react";
// import ScooterLogo from "../../assets/HeaderLogo.png";
import ScooterLogo from "../../assets/HeaderLogo.png";
import useToaster from "../../hooks/useToaster";

/**
 * Full-screen loading indicator with spinner and progress bar.
 * Shows success toast and triggers callback when complete.
 *
 * @param {Function} onComplete - Called when loading finishes
 */
const LoadingPage = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(true);
  const showToast = useToaster();

  useEffect(() => {
    const spinnerTime = 3000;
    const progressBarTime = 7000;

    const spinnerTimeout = setTimeout(() => {
      setIsSpinnerVisible(false);
    }, spinnerTime);

    const progressStartTime = Date.now();

    const progressInterval = setInterval(() => {
      const elapsed = Date.now() - progressStartTime;
      const newProgress = Math.min((elapsed / progressBarTime) * 100, 100);
      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(progressInterval);
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 500);
      }
    }, 100);

    return () => {
      clearTimeout(spinnerTimeout);
      clearInterval(progressInterval);
    };
  }, [onComplete, showToast]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex justify-center items-center">
      {/* Logo */}
      <div className=" flex flex-col w-[400px] h-[126px] items-center justify-center">
        <img
          src={ScooterLogo}
          alt="Scooter Logo"
          className="w-[197px] h-[52px]"
        />
        <div className="mt-auto">
          {isSpinnerVisible ? (
            <div className="w-8 h-8 border-4 border-[#1C40CA] border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <div className="w-[400px] h-[10px] bg-[#F6F7F7] rounded-full overflow-hidden mb-4">
              <div
                className="h-full bg-[#1C40CA] transition-all duration-100 ease-linear"
                style={{ width: `${progress}%` }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
